export default __webpack_public_path__ + "static/media/LoadingUpload.01db0c74.gif";